import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useEventListener } from '../../hooks';
import Icon from '../icon';

const Dropdown = props => {
  const {
    children,
    className,
    disabled,
    title,
    isOpen,
    openOnMouse,
    icon,
    renderIcon,
    leftOrientation,
    rightOrientation,
    toggleClassName
  } = props;
  const [state, setState] = useState({
    open: !!isOpen
  });
  const ddRef = useRef();

  useEffect(() => {
    const { onOpen, onClose, onToggle } = props;
    const handleToggle = state.open ? onOpen : onClose;
    if (handleToggle) handleToggle();
    if (onToggle) onToggle(state.open);
  }, [state, props]);

  const handleClick = event => {
    event.preventDefault();
    if (disabled) return;
    setState({ ...state, open: !state.open });
  };

  const handleMouseEnter = () => {
    if (!disabled && openOnMouse) {
      setState({ ...state, open: true });
    }
  };

  const handleMouseLeave = () => {
    if (!disabled && openOnMouse) {
      setState({ ...state, open: false });
    }
  };

  const handleDocumentClick = e => {
    if (state.open && !ddRef.current?.contains(e.target)) {
      setState({ ...state, open: false });
    }
  };

  useEventListener('click', handleDocumentClick);
  useEventListener('touch', handleDocumentClick);

  return (
    <div
      className={classNames('btn-group', 'justify-content-center', className, { show: state.open })}
      ref={ddRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        type="button"
        className={classNames('btn', 'dropdown-toggle', toggleClassName, { disabled })}
        onClick={e => handleClick(e)}
      >
        {icon && <Icon className={icon} />}
        {renderIcon && renderIcon}
        {title}
      </button>
      <div
        className={classNames('dropdown-menu', {
          show: state.open,
          'dropdown-menu-right': rightOrientation,
          'dropdown-menu-left': leftOrientation
        })}
      >
        {children}
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  renderIcon: PropTypes.node,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onToggle: PropTypes.func,
  openOnMouse: PropTypes.bool,
  rightOrientation: PropTypes.bool,
  leftOrientation: PropTypes.bool,
  toggleClassName: PropTypes.string
};

Dropdown.defaultProps = {
  className: '',
  disabled: false,
  icon: '',
  renderIcon: undefined,
  isOpen: false,
  openOnMouse: false,
  onOpen: undefined,
  onClose: undefined,
  onToggle: undefined,
  rightOrientation: false,
  leftOrientation: false,
  toggleClassName: ''
};

export default Dropdown;
